/*
 * Heuristica para sugerir o tipo de coluna a partir de uma amostra de valores.
 * Retorna 'texto' | 'numero' | 'data' | 'boolean' | 'moeda'.
 */
export function inferTipo(valores) {
    const amostras = (valores || []).filter(v => v != null && v !== '').slice(0, 5);
    if (amostras.length === 0) return 'texto';
    const bools = amostras.every(v => typeof v === 'boolean' || v === 'true' || v === 'false' || v === 0 || v === 1 || v === '0' || v === '1');
    if (bools && !amostras.every(v => typeof v === 'number' && v > 1)) return 'boolean';
    const nums = amostras.every(v => {
        if (typeof v === 'number') return true;
        const s = String(v).replace(/\./g, '').replace(',', '.');
        return /^-?\d+(\.\d+)?$/.test(s);
    });
    if (nums) {
        const hasMoedaMarker = amostras.some(v => /^[\sR$]*\d+[.,]\d{2}$/.test(String(v)));
        return hasMoedaMarker ? 'moeda' : 'numero';
    }
    const datas = amostras.every(v => {
        const s = String(v);
        return /^\d{4}-\d{2}-\d{2}/.test(s)
            || /^\d{2}\/\d{2}\/\d{4}/.test(s)
            || /^\d{2}:\d{2}/.test(s)
            || (!isNaN(Date.parse(s)) && s.length >= 8 && /\d/.test(s));
    });
    if (datas) return 'data';
    return 'texto';
}

export function inferTipoColuna(rows, chave) {
    return inferTipo((rows || []).map(r => r && r[chave]));
}
